// extracted by mini-css-extract-plugin
export default {"BookingNav":"BookingPage_BookingNav__VmDJr","mainBook":"BookingPage_mainBook__u82Dc","return":"BookingPage_return__RaSwi","sub_div":"BookingPage_sub_div__H6huy"};